<template>
  <div>
    <div class="nav">
      <div class="logo">
        <img src="@/assets/images/LOGO3@2x.png" />
        <img src="@/assets/images/slogan.png" />
      </div>
      <div class="mobile">
        <img src="@/assets/images/mobile.png" /><span>18621127542</span>
      </div>
    </div>
    <div class="download">
      <div class="download__item">
        <div class="download__title" @click="handleDownload('ios')">
          <img src="@/assets/images/ios.png" />iOS 下载
        </div>
      </div>
      <div class="download__item">
        <div class="download__title" @click="handleDownload('android')">
          <img src="@/assets/images/android2.png" />安卓下载
        </div>
      </div>
      <div class="download__item">
        <div class="download__title" @click="handleDownload('windows')">
          <img src="@/assets/images/windows.png" />Windows下载
        </div>
      </div>
    </div>
    <div class="intro">
      <div class="intro__item">
        <img src="@/assets/images/intro1.png" />
        <div class="intro__text">丰富趣味有效性</div>
      </div>
      <div class="intro__item">
        <img src="@/assets/images/intro2.png" />
        <div class="intro__text">高级训练师1对1</div>
      </div>
      <div class="intro__item">
        <img src="@/assets/images/intro3.png" />
        <div class="intro__text">训练方案量身定</div>
      </div>
    </div>
    <div class="train">
      <img src="@/assets/images/train1.jpg" @mouseenter="onMouseEnter(1)" />
      <img src="@/assets/images/train2.jpg" @mouseenter="onMouseEnter(2)" />
      <img src="@/assets/images/train3.jpg" @mouseenter="onMouseEnter(3)" />
      <img src="@/assets/images/train4.jpg" @mouseenter="onMouseEnter(4)" />
      <img src="@/assets/images/train5.jpg" @mouseenter="onMouseEnter(5)" />
      <img src="@/assets/images/train6.jpg" @mouseenter="onMouseEnter(6)" />
      <img src="@/assets/images/train7.jpg" @mouseenter="onMouseEnter(7)" />
    </div>
    <div class="train-intro">
      <img v-show="active === 1" src="@/assets/images/train-intro1.jpg" />
      <img v-show="active === 2" src="@/assets/images/train-intro2.jpg" />
      <img v-show="active === 3" src="@/assets/images/train-intro3.jpg" />
      <img v-show="active === 4" src="@/assets/images/train-intro4.jpg" />
      <img v-show="active === 5" src="@/assets/images/train-intro5.jpg" />
      <img v-show="active === 6" src="@/assets/images/train-intro6.jpg" />
      <img v-show="active === 7" src="@/assets/images/train-intro7.jpg" />
    </div>
    <div class="certificate">
      <div class="title">企业资质</div>
      <div class="certs">
        <div class="certs__item">
          <img
            src="@/assets/images/cert0.png"
            @mousemove="onMouseMove"
            @mouseleave="onMouseLeave"
          />
        </div>
        <div class="certs__item">
          <img
            src="@/assets/images/cert3.png"
            @mousemove="onMouseMove"
            @mouseleave="onMouseLeave"
          />
        </div>
        <div class="certs__item">
          <img
            src="@/assets/images/cert4.png"
            @mousemove="onMouseMove"
            @mouseleave="onMouseLeave"
          />
        </div>
      </div>
    </div>
    <div class="connect">
      <div class="phone">
        <div>服务监督: 400-998-6952</div>
        <div>商务合作: 18621127542</div>
      </div>
      <div class="wechat">
        <div>微信扫码</div>
        <div>添加客服</div>
        <img width="150" src="https://test.zskeye.com/resource/dsj-gfkf.png" />
      </div>
    </div>
    <div class="footer">沪ICP备2022028754号-1 沪公网安备31011702008790号</div>
    <!-- 放大镜 -->
    <div ref="zoom" class="zoom"></div>
  </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class Portal extends Vue {
  active = 1

  onMouseEnter(key) {
    this.active = key
  }

  onMouseMove(e) {
    const zoom = this.$refs.zoom
    const imgSrc = e.target.src
    const imgWidth = e.target.width
    const size = 5
    zoom.style.display = 'block'
    zoom.style.left = e.pageX + 10 + 'px'
    zoom.style.top = e.pageY + 10 + 'px'
    zoom.style.backgroundImage = `url(${imgSrc})`
    zoom.style.backgroundPosition = `${-e.offsetX * size + 100}px ${-e.offsetY *
      size +
      100}px`
    zoom.style.backgroundSize = `${imgWidth * size}px auto`
  }

  onMouseLeave() {
    const zoom = this.$refs.zoom
    zoom.style.display = 'none'
  }

  handleDownload(type) {
    const urlMap = {
      ios:
        'https://apps.apple.com/cn/app/%E5%93%86%E8%A7%86%E4%BD%B3%E8%A7%86%E8%A7%89%E8%AE%AD%E7%BB%83%E7%B3%BB%E7%BB%9F/id6473686565',
      android: 'https://test.zskeye.com/resource/dsj.apk',
      windows: 'https://test.zskeye.com/resource/dsj.exe',
    }
    const url = urlMap[type]
    if (url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.nav {
  height: 160px;
  border-bottom: 4px solid #0288e1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15%;
  .logo {
    display: flex;
    align-items: center;
    img {
      margin-right: 10px;
    }
  }
  .mobile {
    display: flex;
    align-items: center;
    img {
      margin-right: 10px;
    }
    span {
      font-size: 40px;
      font-weight: 700;
      color: #393939;
      font-family: impact;
      letter-spacing: 2px;
    }
  }
}
.download {
  height: calc(666 / 1528 * 100vw);
  background: url('../../assets/images/bg1.png') no-repeat center center / cover;
  padding: 0 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &__item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-align: center;
    width: 300px;
    height: 90px;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 45px;
    margin-right: 15px;
    &:last-child {
      margin-right: 0;
    }
  }
  &__title {
    font-size: 30px;
    line-height: 80px;
    cursor: pointer;
    text-wrap: nowrap;

    img {
      margin-right: 15px;
      vertical-align: -3px;
    }
    &.small {
      font-size: 26px;
      line-height: 1.5;
      margin-top: 20px;
      cursor: pointer;
    }
  }
  &__divider {
    height: 4px;
    border: 1px solid #666;
    width: 80%;
    background-color: #c9c9c9;
    border-radius: 5px;
  }
}
.intro {
  display: flex;
  padding: 30px calc(75 / 1528 * 100vw);
  justify-content: space-between;
  &__item {
    width: 30%;
    // height: 564px;
    position: relative;
    img {
      width: 100%;
    }
  }
  &__text {
    position: absolute;
    width: 100%;
    height: 117px;
    line-height: 117px;
    text-align: center;
    bottom: 110px;
    background-color: rgba(255, 255, 255, 0.5);
    font-size: 22px;
    color: #545454;
  }
}

.train {
  padding: 30px calc(75 / 1528 * 100vw);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  img {
    filter: grayscale(100%);
    width: calc(100% / 7);
    &:hover {
      filter: none;
    }
  }
}
.train-intro {
  height: calc(630 / 1528 * 100vw);
  display: flex;
  justify-content: center;
  overflow: hidden;
  img {
    display: block;
    height: 100%;
  }
}
.certificate {
  height: calc(558 / 1528 * 100vw);
  background: url('../../assets/images/cert-bg1.png') no-repeat bottom/contain;
  .title {
    text-align: center;
    height: calc(150 / 1528 * 100vw);
    line-height: calc(150 / 1528 * 100vw);
    font-size: 36px;
    font-weight: 700;
    color: #4e4e4e;
  }
  .certs {
    display: flex;
    padding: 0 calc(170 / 1528 * 100vw);
    justify-content: space-between;
    &__item {
      background: url('../../assets/images/cert-border.png') no-repeat
        center/contain;
      padding: 1.8%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    img {
      height: calc(320 / 1528 * 100vw);
      flex-shrink: 1;
      box-shadow: 0 0 10px #fff;
    }
  }
}
.connect {
  display: flex;
  justify-content: space-between;
  background: #0288e1;
  padding: 0 calc(75 / 1528 * 100vw) 20px;
  color: #fff;
  .phone {
    margin-top: 40px;
    font-weight: 700;
    line-height: 40px;
  }
  .wechat {
    margin-top: 15px;
    font-size: 24px;
    font-weight: 500;
    line-height: 35px;
    text-align: center;
  }
}
.footer {
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.zoom {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  width: 200px;
  height: 200px;
  pointer-events: none;
  background-repeat: no-repeat;
  border-radius: 50%;
  border: 1px solid #ffc10a;
  background-color: #fff;
}
</style>
